/**
 * Collapses the remaining option values of a long option list behind a toggle.
 *
 * The variant picker is re-rendered server side on every variant change, which replaces this element. The expanded
 * state is therefore kept on the class and restored on connect, so an option list the customer opened stays open
 * after picking a value.
 */
class VariantOptionCollapse extends HTMLElement {
  static expandedStates = new Map();

  connectedCallback() {
    this.toggle = this.querySelector('[data-collapse-toggle]');

    if (!this.toggle) {
      return;
    }

    this.onToggleClick = this.handleToggleClick.bind(this);
    this.toggle.addEventListener('click', this.onToggleClick);
    this.setExpanded(VariantOptionCollapse.expandedStates.get(this.optionKey) === true);
  }

  disconnectedCallback() {
    if (this.toggle && this.onToggleClick) {
      this.toggle.removeEventListener('click', this.onToggleClick);
    }
  }

  get optionKey() {
    return this.getAttribute('option-key') || '';
  }

  get expanded() {
    return this.hasAttribute('expanded');
  }

  handleToggleClick() {
    const expanded = !this.expanded;

    VariantOptionCollapse.expandedStates.set(this.optionKey, expanded);
    this.setExpanded(expanded);
  }

  setExpanded(expanded) {
    this.toggleAttribute('expanded', expanded);
    this.toggle.setAttribute('aria-expanded', String(expanded));

    const label = this.toggle.querySelector('[data-collapse-label]');
    const text = expanded ? this.toggle.dataset.labelLess : this.toggle.dataset.labelMore;

    if (label && text) {
      label.textContent = text;
    }
  }
}

if (!window.customElements.get('variant-option-collapse')) {
  window.customElements.define('variant-option-collapse', VariantOptionCollapse);
}
